export const TECHNOLOGIES = [
  { name: "Intel·ligència Artificial", icon: "BrainCircuit" },
  { name: "Machine Learning", icon: "Network" },
  { name: "OCR", icon: "ScanText" },
  { name: "MongoDB", icon: "Database" },
  { name: "React", icon: "Atom" },
  { name: "Node.js", icon: "Hexagon" },
  { name: "FastAPI", icon: "Zap" },
  { name: "Railway", icon: "Train" },
  { name: "GitHub", icon: "Github" },
  { name: "API REST", icon: "Webhook" },
  { name: "QR", icon: "QrCode" },
  { name: "PWA", icon: "Smartphone" },
  { name: "Cloud", icon: "Cloud" },
  { name: "Automatitzacions", icon: "Workflow" },
  { name: "Geolocalització", icon: "MapPin" },
  { name: "Pagaments", icon: "CreditCard" },
  { name: "Notificacions Push", icon: "Bell" },
  { name: "Seguretat", icon: "ShieldCheck" },
];
